module.exports = __webpack_public_path__ + "images/RebrandedWebMainAreaHeroBackground-f137e77a6efbaad22e058f3a1dd29acd.png";